import React, { Component } from 'react';
import BookdocLogo          from 'assets/logos/Sidebar.svg';
import MobileMenu           from 'assets/icons/Mobile Menu.svg';
import { NavLink }          from 'react-router-dom';
import { ProfileContent }   from 'components/DesktopNavbar/ProfileContent';
import { SidebarLinks }     from 'components/DesktopSidebar/SidebarLinks';

export class MobileNavbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profileDropdown: false
    };
  }

  toggleDropdown() {
    var body = document.querySelector('body');

    if (this.state.profileDropdown) {
      body.classList.remove('modal-open');
      body.style.removeProperty('overflow');
    } else {
      body.classList.add('modal-open');
      body.setAttribute('style', 'overflow: hidden;');
    }

    this.setState({  profileDropdown: !this.state.profileDropdown });
  }

  render() {
    return (
      <div id="mobile-navbar" className="d-block d-lg-none">
        <div id="mobile-navbar-bg" className="d-flex justify-content-between align-items-center bg-white">
          <NavLink end={ true } to="/eb" className="h-100" >
            <img src={ BookdocLogo } alt="bookdoc-logo" className="p-5 h-100"/>
          </NavLink>

          <img src={ MobileMenu } alt="mobile-menu" className="px-8 py-5 h-100" onClick={() => this.toggleDropdown() } />
        </div>

        <div id="mobile-popup" data-displayed={ this.state.profileDropdown }>
          <div id="mobile-popup-links">
            <SidebarLinks triggerDropdown={() => this.toggleDropdown() } />
          </div>

          <div id="mobile-popup-profile" className="px-6">
            <ProfileContent triggerDropdown={() => this.toggleDropdown() } />
          </div>
        </div>
      </div>
    )
  }
}